// Report Actions
export const SAVE_AS_NEW = 'SAVE_AS_NEW';
export const DELETE_REPORT = 'DELETE_REPORT';
export const APPLY_DRAFT = 'APPLY_DRAFT';
export const REVERT_DRAFT = 'REVERT_DRAFT';
export const TOGGLE_BOOKMARK = 'TOGGLE_BOOKMARK';
export const RENAME_REPORT = 'RENAME_REPORT';

// Report Group Actions
export const CREATE_REPORT_GROUP = 'CREATE_REPORT_GROUP';
export const RENAME_REPORT_GROUP = 'RENAME_REPORT_GROUP';
export const GROUP_REPORTS = 'GROUP_REPORTS';
export const UNGROUP_REPORTS = 'UNGROUP_REPORTS';
export const DELETE_REPORT_GROUP = 'DELETE_REPORT_GROUP';

// Report Dashboard Pin Actions
export const ADD_DASHBOARD_PIN = 'ADD_DASHBOARD_PIN';
export const REMOVE_DASHBOARD_PIN = 'REMOVE_DASHBOARD_PIN';
export const UPDATE_DASHBOARD_PIN = 'UPDATE_DASHBOARD_PIN';
export const REORDER_DASHBOARD_PINS = 'REORDER_DASHBOARD_PINS';